import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Creatable from "react-select/lib/Creatable";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import moment from "moment";
import { buildOptions } from "../utils";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

class LivingArrangementHistoryFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentLivingArrangements(livingArrangement) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          living_arrangements_attributes: [livingArrangement]
        }
      })
    })
  }

  deleteLivingArrangement() {
    const { livingArrangement, deleteLivingArrangement, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateResidentLivingArrangements({
      id: livingArrangement.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false });
      deleteLivingArrangement(livingArrangement);
      if (isStaffApp) {
        alert('Living Arrangement successfully deleted.')
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  saveLivingArrangementHistoryFunction = (e) => {
    this.props.dispatch(this.saveLivingArrangementHistory())
  }

  componentDidMount() {
    document.addEventListener('saveLivingArrangementHistory', this.saveLivingArrangementHistoryFunction)
  }

  componentWillUnmount() {
    document.removeEventListener('saveLivingArrangementHistory', this.saveLivingArrangementHistoryFunction)
  }

  saveLivingArrangementHistory() {
    const { livingArrangement, updateLivingArrangements, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateResidentLivingArrangements(livingArrangement).then((data) => {
      this.setState({ loading: false });
      updateLivingArrangements(data.living_arrangements);
      if (isStaffApp) {
        alert('Living Arrangement changes saved.');
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  render() {
    const { arrangement, started_at, ended_at, notes } = this.props.livingArrangement;
    const { isStaffApp, hasDelete, hasEdit } = this.props;
    const arrangementOptions = buildOptions([
      "Own", "Rent", "Dorm", "Sober Living", "Treatment"
    ]);
    const arrangementValue = arrangementOptions.find((option) => option.value === arrangement);

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Living Arrangement</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="livingArrangementArrangement">
                <Form.Label>Arrangement</Form.Label>
                <Creatable
                  options={arrangementOptions}
                  value={arrangementValue}
                  onChange={(option) => {
                    this.handleChange('arrangement', option.value)
                  }} />
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="livingArrangementStartedAt">
                    <Form.Label>Started At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={started_at ? moment(started_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "started_at",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="livingArrangementEndedAt">
                    <Form.Label>Ended At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={ended_at ? moment(ended_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "ended_at",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="livingArrangementNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  value={notes}
                  onChange={(e) => {
                    this.handleChange("notes", e.target.value)
                  }} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Arrangement</Form.Label>
                <div className="form-control-plaintext">{arrangement || 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Started At</Form.Label>
                    <div className="form-control-plaintext">{started_at ? moment(started_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Ended At</Form.Label>
                    <div className="form-control-plaintext">{ended_at ? moment(ended_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ? (
          <Modal.Footer>
            {
              this.props.action === "edit" && hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => this.deleteLivingArrangement()}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              onClick={() => this.saveLivingArrangementHistory()}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer>)
          : (
            <div className="p-4">
              {this.props.action == "edit" && hasDelete && (
                <Button
                  onClick={() => this.deleteLivingArrangement()}
                  variant="outline-danger"
                  className="w-100"
                >
                  Delete
                </Button>
              )}
            </div>
          )
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.livingArrangementHistoryModal.show,
    livingArrangement: state.ui.livingArrangementHistoryModal.livingArrangementHistory,
    action: state.ui.livingArrangementHistoryModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
    isStaffApp: state.config.isStaffApp,
    resident_tabs: state.config.resident_tabs,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab => tab.detail == 'living_arrangement_history'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit'),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "livingArrangementHistory" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "livingArrangementHistory", name, value }
      });
    },
    updateLivingArrangements: (livingArrangements) => {
      dispatch({
        type: "UPDATE_LIVING_ARRANGEMENTS",
        payload: { livingArrangements }
      });
    },
    createLivingArrangement: (livingArrangement) => {
      dispatch({
        type: "CREATE_LIVING_ARRANGEMENT",
        payload: { livingArrangement }
      });
    },
    deleteLivingArrangement: (livingArrangement) => {
      dispatch({
        type: "DELETE_LIVING_ARRANGEMENT",
        payload: { livingArrangement }
      })
    }
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(LivingArrangementHistoryFormModal));
